import { getSession as getNextAuthSession } from '#pplx/frontend/auth/core.js';
import { AuthError } from '#pplx/frontend/auth/errors.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
export const SESSION_KEY = 'pplx-next-auth-session';
let sessionFetch = null;
const getLocalSession = () => {
    try {
        const session = SafeLocalStorage.getItem(SESSION_KEY);
        return session ? JSON.parse(session) : null;
    }
    catch {
        return null;
    }
};
/** @internal */
export const setLocalSession = (session) => {
    session && SafeLocalStorage.setItem(SESSION_KEY, JSON.stringify(session));
};
export const clearLocalSession = () => {
    SafeLocalStorage.removeItem(SESSION_KEY);
};
/**
 * Gets the next-auth session. If the session was previously stored in local storage,
 * it may be returned immediately (depending on the expiredOk flag), else it will be
 * awaited on from next-auth.

 * @param expiredOk - If true, return a local storage session even if it's expired.
 * @returns The session, or null if there is no session.
 */
export const getSession = (expiredOk = false) => {
    sessionFetch ??= getNextAuthSession()
        .then((session) => {
        if (session) {
            setLocalSession(session);
        }
        else {
            clearLocalSession();
        }
        return session;
    })
        .catch((error) => {
        if (!(error instanceof AuthError) || error.code !== 'AUTH_NO_STATUS_CODE_ERROR') {
            setLocalSession(null);
        }
        throw error;
    })
        .finally(() => {
        sessionFetch = null;
    });
    const session = getLocalSession();
    if (session && (expiredOk || new Date(session.expires) > new Date())) {
        return {
            cachedSession: session,
            sessionFetchPromise: sessionFetch,
        };
    }
    return {
        cachedSession: null,
        sessionFetchPromise: sessionFetch,
    };
};
//# sourceMappingURL=getSession.js.map